/**
 * 微信支付账单
 */
import React from 'react';
import { Row, Col, DatePicker, Button, Icon, Tooltip, Input, Select } from 'antd';
import PageLayout from '../../ui/PageLayout';
//消息提示
import http from '../../../axios/http';
import PayOrderDetail from './PayOrderDetail';
import Loading from '../../ui/Loading';
import DictSelect from '../../ui/DictSelect';
import PayOrderApply from './PayOrderApply';
import PayOrderApproval from './PayOrderApproval';
import { global_data } from '../../ui/auth'

class InstallmentApplyIndex extends React.Component {

    columns = [
        {
        title: '账单编号',
        dataIndex: 'orderId',
        width: '10%',
    }
    , {
        title: '微信用户openid',
        dataIndex: 'subOpenId',
        width: '10%',
    }
    , {
        title: '账单类型',
        dataIndex: 'typeStr',
        width: '10%',
    }
    , {
        title: '订单编号',
        dataIndex: 'typeId',
        width: '12%',
    }
    // , {
    //     title: '商户号/终端号',
    //     dataIndex: 'midTid',
    //     width: '12%',
    // }
    ,{
        title: '支付金额',
        dataIndex: 'totalAmountD',
        width: '7%',
    }, {
        title: '付款人',
        dataIndex: 'creatorName',
        width: '7%',
    }, 
    {
        title: '账单状态',
        dataIndex: 'statusStr',
        width: '7%',
    }, 
    {
        title: '车牌或车架号',
        dataIndex: 'plateNoOrVin',
        width: '7%',
    }, 
    {
        title: '账单创建时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '7%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("PAY_ORDER_MANAGE_REFUND_APPLY")&&record["status"] === "TRADE_SUCCESS" ?
                 <Tooltip title="退款申请">
                    <Icon type="pay-circle" theme="filled" style={{ color: '#d3981a' }}className="table-operate-icon" onClick={this.refund.bind(this, record.orderId)} />
                </Tooltip> 
                : ""}
                {global_data.authCode.includes("PAY_ORDER_MANAGE_REFUND_AUDIT")&&record["refundStatus"] === "PROCESSING" ? 
                <Tooltip title="退款审核">
                    <Icon type="pay-circle" theme="filled" style={{ color: '#0ea10e' }} className="table-operate-icon" onClick={this.refundApproval.bind(this, record.orderId)} />
                </Tooltip> 
                : ""}
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        loadData: '',
        queryData: {},
        detailVisible: false,
        editData: {},
        loadingVisible: false,    //导出遮罩
        //审批弹框
        visible:false,
        ApprovalVisible:false
    };

    detail = (info) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/payOrder/query/detail',
            data: { id: info.id },
            success: (res) => {
                this.setState({ editData: res, detailVisible: true, loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    refund = (orderId) => {
        this.setState({ visible: true, editData: orderId });

    }

    refundApproval = (orderId) => {
        this.setState({ ApprovalVisible: true, editData: orderId });
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/payOrder/download',
            data: queryData,
            fileName: "微信支付账单信息表.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="订单编号"
                                    onSearch={this.onChange.bind(this, "typeId")}
                                    enterButton
                                    style={{ width: '200px', margin: '10px 30px 0 0' }}
                                />
                                <Input.Search
                                    placeholder="账单编号"
                                    onSearch={this.onChange.bind(this, "orderId")}
                                    enterButton
                                    style={{ width: '200px', margin: '10px 30px 0 0' }}
                                />
                                {/* <Input.Search
                                    placeholder="账单备注"
                                    onSearch={this.onChange.bind(this, "orderDesc")}
                                    enterButton
                                    style={{ width: '200px', margin: '10px 30px 0 0' }}
                                /> */}
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '10px 30px 0 0' }} />
                                <DictSelect placeholder="付款状态" category="PAY_ORDER_STATUS" allowClear={true} style={{ width: '150px', margin: '10px 30px 0 0' }} onChange={this.onChange.bind(this, "status")} />
                                <DictSelect placeholder="退款状态" category="PAY_REFUND_ORDER_STATUS" allowClear={true} style={{ width: '150px', margin: '10px 30px 0 0' }} onChange={this.onChange.bind(this, "refundStatus")} />
                                <Select placeholder="交易类型" allowClear={true} style={{ width: '150px', margin: '10px 30px 0 0' }} onChange={this.onChange.bind(this, "type")} >
                                    <Select.Option key="time_park_fee">停车费</Select.Option>
                                    <Select.Option key="vehicle_check_fee">车辆检测费</Select.Option>
                                    <Select.Option key="appointment_fee">预约看车费</Select.Option>
                                    <Select.Option key="trade_tax">车辆过户交易税</Select.Option>
                                    <Select.Option key="trade_tax_seller">车辆过户卖家交易税</Select.Option>
                                    <Select.Option key="trade_tax_buyer">车辆过户买家交易税</Select.Option>
                                </Select>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/payOrder/query/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <PayOrderDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                />
                <Loading visible={this.state.loadingVisible} message="请稍候..." />
                <PayOrderApply
                    visible={this.state.visible}
                    onCancel={() => this.setState({ visible: false })}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <PayOrderApproval
                    visible={this.state.ApprovalVisible}
                    onCancel={() => this.setState({ ApprovalVisible: false })}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default InstallmentApplyIndex;